<div class="w-100">
  <ValidationObserver v-slot="{ handleSubmit }" ref="formRef">
    <form @submit.prevent>
      <div v-for="(partner,index) in contractPartners" :key="index">
        <div class="card najiz-card-panel mb-5">
          <div class="card-header najiz-panel-header">
            <h4 class="mb-0 py-3">
              <b>
                <span v-if="partner.partnerTarafTypeId==1">بيانات الطرف الأول</span>
                <span v-if="partner.partnerTarafTypeId==2">بيانات الطرف الثاني</span>
                <span v-if="partner.partnerTarafTypeId==3">بيانات المحامي</span>
              </b>
            </h4>
          </div>
          <div class="collapse show">
            <div class="card-body" v-if="partner.isViewMode">
              <div v-if="partner.socialId">
                <div class="d-flex justify-content-between">
                  <h4 class="py-3">
                    <b>
                      {{partner.fullname}}
                    </b>
                  </h4>
                  <a v-if="index==0" @click="editPartner(index,partner)">
                    <img src="/applications/contracts/img/Edit.svg" width="40" alt="Edit partner" />
                  </a>
                  <a v-if="index!=0" @click="removePartner(index,partner)">
                    <i class="fal fa-trash-alt fa-lg" style="color: #c6585d;"></i>
                  </a>
                </div>
                <div class="form-row justify-content-start" v-if="partner">
                  <div class="col-lg-2 col-md-2 col-sm-12">
                    <label for="disabledTextInput">الجنسية</label>
                    <p><b>{{partner.nationalityDescAr}}</b></p>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-12" v-if="partner.socialId">
                    <label for="disabledTextInput">نوع الهوية</label>
                    <p><b>{{partner.socialId | getSocialIdType}}</b></p>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-12">
                    <label for="disabledTextInput">رقم الهوية</label>
                    <p><b>{{partner.socialId}}</b></p>
                  </div>
                  <div class="col-lg-1 col-md-1 col-sm-12">
                    <label for="disabledTextInput">النوع</label>
                    <p><b>{{partner.genderDesc}}</b></p>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-12" v-if="partner.birthDate">
                    <label for="disabledTextInput">تاريخ الميلاد</label>
                    <p><b> {{partner.birthDateHijri}} هـ - {{partner.birthDate|getFormattedDate}}م</b></p>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-12">
                    <label>رقم الجوال <a @click="setMobileEditMode(partner)" v-if="index > 0"><i
                          class="fa fa-edit"></i></a></label>
                    <p v-if="!partner.isEditMobileNumber"> <b> {{partner.mobileNumber}} </b></p>
                    <div class="d-flex" v-if="partner.isEditMobileNumber">
                      <MobileComponent v-model="partner.mobileNumber"></MobileComponent>
                      <button type="submit" class="btn btn-default btn-accept mr-2 ml-2"
                        @click="handleSubmit(editMobile(partner))">
                        <i class="fal fa-check"></i>
                      </button>
                      <button type="submit" class="btn btn-default btn-cancel" @click="cancelEditMobile(partner)">
                        <i class="fal fa-times"></i>
                      </button>
                    </div>
                  </div>
                  <template v-if="partner.partnerTarafTypeId === 3">
                    <div class="col-lg-2 col-md-2 col-sm-12">
                      <label for="disabledTextInput">نوع الرخصة</label>
                      <p><b>{{partner.licenseStatus}}</b></p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12">
                      <label for="disabledTextInput">تاريخ بداية الرخصة</label>
                      <p><b>{{partner.licenceDateHijri}} هـ</b></p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12">
                      <label for="disabledTextInput">تاريخ نهاية الرخصة</label>
                      <p><b>{{partner.licenceEndDateHijri}} هـ</b></p>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <ApplicantComponent @addActivePartner="addActivePartner" v-if="partner.formType==0 && !partner.isViewMode"
              :key="partner.formType" :tarafType="partner.formType" :partner="partner"></ApplicantComponent>
            <TarafComponent @addActivePartner="addActivePartner"
              v-if="partner.formType!=0 && partner.formType!=4 && !partner.isViewMode" :key="partner.formType"
              :tarafType="partner.formType" :partner="partner"></TarafComponent>
          </div>
        </div>
      </div>
      <div id="accordion" v-if="contractPartners && contractPartners.length==0">
        <div class="card najiz-card-panel mb-5">
          <div class="card-header najiz-panel-header" id="headingOne">
            <h4 class="mb-0 py-3">
              <b>
                <span v-if="formFormType==0">بيانات مقدم الطلب</span>
              </b>
            </h4>
          </div>
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
            <ApplicantComponent @addActivePartner="addActivePartner" v-if="formFormType==0" :key="formFormType"
              :tarafType="formFormType" :partner="applicantPartner">
            </ApplicantComponent>
          </div>
        </div>
      </div>
      <hr class="footer-hr" />
      <div class="d-flex">
        <button type="button" class="btn btn-link text-danger ml-auto pr-0 text-decoration-none"
          @click="onCancel">إلغاء</button>
        <button type="submit" class="btn button--greenFill px-8" @click="handleSubmit(nextStep)">التالي</button>
      </div>
    </form>
  </ValidationObserver>
</div>